import { Action, createReducer, on } from '@ngrx/store';
import { fetchTeamMembersListData, fetchTeamMembersListSuccess, fetchTeamMembersListFailure, blockTeamMember, blockTeamMemberSuccess, blockTeamMemberFailure, addTeamMember, addTeamMemberSuccess, addTeamMemberFailure } from "./teammember.actions";
import { cloneDeep } from 'lodash';
import { TeamMemberModel } from '../../core/models/teammember.models';
import { TeamModel } from '../../core/models/team.models';

export interface TeamMemberState {
    memberdata: TeamModel | null;
    loading: boolean;
    error: any;
}

export const initialState: TeamMemberState = {
    memberdata: null,
    loading: false,
    error: null,
};

export const teammemberReducer = createReducer(
    initialState,

    // TeamMember
    on(fetchTeamMembersListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchTeamMembersListSuccess, (state, { memberdata }) => {
        return { ...state, memberdata, loading: false };
    }),
    on(fetchTeamMembersListFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(blockTeamMember, (state) => ({ ...state, loading: true, error: null })),
    on(blockTeamMemberSuccess, (state, { userguid }) => {
        return { ...state, loading: false, error: null };
      }),
    on(blockTeamMemberFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(addTeamMember, (state) => ({ ...state, loading: true, error: null })),
    on(addTeamMemberSuccess, (state, { teamMember : member }) => {
        return { ...state, loading: false, error: null };
      }),
    on(addTeamMemberFailure, (state, { error }) => ({ ...state, error, loading: false })),
);

// Selector
export function reducer(state: TeamMemberState | undefined, action: Action) {
    return teammemberReducer(state, action);
}
